import React from 'react';
import { connect } from 'react-redux';
import { authLogout } from '../../../actions/auth';
import { ConfirmAssociationFormView } from '../../../components';
import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class ConfirmAccountAssociation extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    modalViewGA('confirm-association');
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
    if (!this.props.userId) {
      this.props.dispatch(authLogout());
    }
  }

  render() {
    const { provider, email } = this.props;
    return (
      <div>
        <div className="modals-popup link-account-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Link your social and Explore accounts</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={this.closeModal}></a>
            </div>
          </div>
          <div className="info">
            <div className="text-center">
              <p>It looks like you already have an account with the email address:</p>
              <p className="email">{email}</p>
              <p>Please enter your existing Explore.org password and
                click continue to link your Social and Explore accounts.</p>
            </div>
            <ConfirmAssociationFormView removeModal={this.props.removeModal}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    provider: state.auth.provider,
    email: state.auth.email,
    userId: state.auth.userId,
  };
};

export default connect(mapStateToProps)(ConfirmAccountAssociation);
